import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import FilterSelect from "../../../components/select/filterSelect";
import InputDatePicker from "../../../components/input/inputDatePicker";
import moment from "moment";
import { MenuItem, useMediaQuery, useTheme } from "@mui/material";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  FiberManualRecord,
  NavigateNext,
  SearchOutlined,
} from "@mui/icons-material";
import CustomStatus from "../../../components/chip/CustomStatus";
import { StudentApi } from "../../../api/student/student.api";
import StateComponents from "../../../components/state-component/StateComponents";
import { debouncedApiCall } from "../../../utils/app.utils";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../../admission/history-online-Admission/enum/admission.enum";
import { useTranslation } from "react-i18next";

type Props = {};

const ManageStudents: React.FC<Props> = (props: Props) => {
  const { t, i18n } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const [dataStudents, setDataStudent] = useState<any[]>([]);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const [keyword, setKeyword] = useState<string>("");
  const [degree, setDegree] = useState<any[]>([]);
  const [faculty, setFaculty] = useState<any[]>([]);
  const [id_degree, set_id_degree] = useState<any>("ALL");
  const [id_faculty, set_id_faculty] = useState<any>("ALL");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const handleColorStatus = (status_type: string) => {
    if (status_type === "active") {
      return "success";
    } else if (status_type === "inactive") {
      return "error";
    } else {
      return "error";
    }
  };
  const handleTextStatus = (status_type: string) => {
    if (status_type === "active") {
      return t("กำลังศึกษา");
    } else if (status_type === "inactive") {
      return t("ไม่ได้ศึกษาแล้ว");
    } else {
      return "ข"; // i18n-ignore (unused placeholder)
    }
  };

  const headCells = [
    {
      id: "#",
      width: 100,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 300,
      disablePadding: false,
      align: "start",
      label: t("ชื่อ - นามสกุล"),
    },

    {
      id: "student_no",
      disablePadding: false,
      align: "center",
      width: 300,
      label: t("รหัสประจำตัวนักศึกษา"),
    },
    {
      id: "education_level",
      disablePadding: false,
      align: "center",
      width: 200,
      label: t("ระดับ"),
    },
    {
      id: "course",
      disablePadding: false,
      width: 200,
      align: "center",
      label: t("คณะ"),
    },
    {
      id: "year_study",
      disablePadding: false,
      align: "center",
      width: 200,
      label: t("ปีที่เข้ารับการศึกษา"),
    },
    {
      id: "year_graduation",
      disablePadding: false,
      align: "center",
      width: 200,
      label: t("ปีที่จบการศึกษา"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 250,
      label: t("สถานะ"),
    },
    {
      id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && dataStudents.length > 0, label: ""
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_student,
      student_no,
      title,
      student_frist_name,
      student_middle_name,
      student_last_name,
      status,
      student_status,
      id_student_term_payment,
      id_student_register_payment,
      faculty_name,
      degree_name,
      academic_year,
      academic_year_end
    } = objData;

    const objRenderData = {
      key: id_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: no || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label:
            title +
            " " +
            student_frist_name +
            " " +
            student_middle_name +
            " " +
            student_last_name || "-",
        },

        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: student_no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: degree_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: faculty_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: academic_year || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: academic_year_end || "-",
        },
        // {
        //   option: "TEXT",
        //   align: "center",
        //   label: (
        //     <CustomStatus
        //       label={handleTextStatus(status)}
        //       type="outlined"
        //       color={handleColorStatus(status)}
        //       icon={<FiberManualRecord />}
        //       width="100px"
        //     />

        //   ),
        // },
        {
          option: "COMPONENT",
          align: "center",
          component: <StatusCustom
            disableMaxWidth
            text={renderStatus(student_status)}
            type={renderStatus(student_status)}
          />,
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches && dataStudents.length > 0,
          component: (
            <NavigateNext
              onClick={() => {
                navigate(
                  routeName.cms.ManageStudents +
                  `/detail/${id_student}?id_student_term_payment=${id_student_term_payment || ''}&id_student_register_payment=${id_student_register_payment || ""}`
                );
              }}
              style={{
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };


  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getStudents = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    if (keyword) query = { ...query, keyword: keyword }
    // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
    // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
    if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
    if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
    await StudentApi.getAllStudents(query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
        setDataStudent(data.data.items);
      } else {
        setDataStudent([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  useEffect(() => {
    getStudents();
  }, [page, pageLimit, sortBy, sortType, keyword, id_degree, id_faculty]);

  const getDegree = async () => {
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        setDegree(res.data?.data || []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  const getFaculty = async () => {
    await facultyApi.getFaculty().then((res) => {
      if (res.status < 300) {
        setFaculty(res.data?.data || []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  useEffect(() => {
    getDegree()
    getFaculty()
  }, [])
  return (
    <div>
      <ContentHeading
        title={"TOPIC.MANAGE_STUDENTS"}
        detail="HEADING.SELECT_LIST"
      />

      {/* <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อ - นามสกุล/ชื่อฉายา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValueSearch("name", e.target.value);
            }}
            value={inputValueSearch.name}
          />
        </article>

        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3">
          <InputDatePicker
            helperText={""}
            placeholder="ช่วงปีที่เข้ารับการศึกษา"
            value={inputValueSearch.year_study}
            allowClear
            disableFuture
            onChange={(e: any) => {
              handleChangeValueSearch(
                "year_study",
                moment(e).format("YYYY-MM-DD")
              );
            }}
          />
        </article>

        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3">
          <FilterSelect
            value={inputValueSearch.courses ?? ""}
            // renderValue={() => "ทุกหลักสูตร"}
            labelId="courses-id"
            selectId="courses-select-id"
            options={dataCourses.map((list, index) => (
              <MenuItem value={list.id} key={index + 1}>
                {list.name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("courses", e.target.value)
            }
          />
        </article>
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            // renderValue={() => "ทุกสถานะ"}
            labelId="status-id"
            selectId="status-select-id"
            options={dataStatus.map((list, index) => (
              <MenuItem value={list.id} key={index + 1}>
                {list.name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>
      </div> */}
      <StateComponents
        otherProps={{ spacing: 2 }}
        sxContainer={{ margin: '20px 0px' }}
        typeProps={[
          {
            seq: 1,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
              md: 4
            },
            fieldProps: {
              placeholder: t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา"),
              onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
            }
          },
          {
            seq: 2,
            type: "SELECT",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              labelId: "ss",
              heading: "",
              onChange: (e) => {
                // handleChange('form_type', index, e.target.value);
                set_id_degree(e.target.value)
              },
              options: [{
                label: t('ระดับทั้งหมด'),
                value: "ALL",
              }, ...degree?.map((item: any) => {
                return {
                  label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                  value: item?.id_degree,
                }
              })],
              selectId: "",
              value: id_degree || '',
            }
          },
          {
            seq: 3,
            type: "SELECT",
            gridProps: {
              xs: 12,
              md: 3
            },
            fieldProps: {
              labelId: "ss",
              heading: "",
              onChange: (e) => {
                // handleChange('form_type', index, e.target.value);
                set_id_faculty(e.target.value)
              },
              options: [{
                label: t('คณะทั้งหมด'),
                value: "ALL",
              }, ...faculty?.map((item: any) => {
                return {
                  label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                  value: item?.id_faculty,
                }
              })],
              selectId: "",
              value: id_faculty || '',
            }
          },

        ]}
      />

      <section className="w-full">

        <TableCustom
          tableMinWidth={1600}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={dataStudents?.map((data: any, i: any) => {
            return renderData(data, i)
          })}
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageStudents;
